import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { LazyLoadImageModule } from 'ng-lazyload-image';

/** Banner component that displays app download options for Android and iOS */
@Component({
  selector: 'app-banner-app-downloads',
  imports: [LazyLoadImageModule],
  templateUrl: './banner-app-downloads.html',
  styleUrl: './banner-app-downloads.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BannerAppDownloads {
  /** Title text displayed in the banner */
  readonly title = input<string | undefined>('');
  /** Subtitle text displayed under the title */
  readonly subtitle = input<string | undefined>('');
  /** URL or path to the Android image asset */
  readonly imageAndroid = input<string | undefined>('');
  /** URL or path to the iOS image asset */
  readonly imageIos = input<string | undefined>('');

  /** Additional CSS classes for the content container */
  readonly classesContent = input<string>('pt-3 ps-3 pe-5');

  /** Background image for the banner */
  readonly imageBackground = input<string>('/img/banner-vr.png');

  /** Event emitted when the Android download/button is clicked */
  readonly clickAndroidChange = output<void>();
  /** Event emitted when the iOS download/button is clicked */
  readonly clickIosChange = output<void>();

  /**
   * Handle Android button click and emit the Android click event
   */
  protected clickAndroid(): void {
    this.clickAndroidChange.emit();
  }

  /**
   * Handle iOS button click and emit the iOS click event
   */
  protected clickIos(): void {
    this.clickIosChange.emit();
  }
}
